module.exports = __webpack_public_path__ + "static/media/yellow.b2b8b8fc.jpg";